// eslint-disable-next-line no-restricted-imports
import { ApolloError } from '@apollo/client';
import { ServerError } from 'api/types/error';

/** Handle apollo error */
export const parseServerError = (error?: unknown) => {
  if (error instanceof ApolloError) {
    if (error.graphQLErrors) {
      const graphQLErrors = error.graphQLErrors[0]?.extensions as {
        response: { status: number; body: ServerError };
      };

      if (!graphQLErrors) {
        return false;
      }

      const serverError = graphQLErrors.response?.body;

      if (serverError?.localizedDescription) {
        serverError.message = serverError.localizedDescription;
        return serverError;
      }

      const status = graphQLErrors.response?.status;
      if (status === 401) {
        return undefined;
      }
    }

    return false;
  }

  return undefined;
};
